<div *ngIf="!hasPictures && !pictures?.length">
  <h1>The selected answer doesn't have any pictures</h1>
</div>

<div *ngIf="pictures?.length" class="main-div">
  <div id="left-column" [ngStyle]="{ flex: showFlags ? flexValue : '1' }">
    <app-picture-viewer
      #viewerFull
      [picture]="pictures[currentPicture]"
      [flags]="currentFlags"
      [flagsWithTooltip]="flagsWithTooltip"
      [placeholderFlag]="placeholderFlag"
      (addFlag)="addFlag($event)"
      (editFlag)="editFlag($event)"
      (markupChanged)="markupChanged()"
      (moveFlag)="moveFlag($event)"
      [disableFullscreen]="true"></app-picture-viewer>

    <div class="flag-panel">
      <a
        class="notification-flags"
        (click)="unpinnedFlagsCount() !== 0 && toggleFlags()"
        [class.disabled-link]="unpinnedFlagsCount() === 0">
        <i
          class="fa fa-flag fa-1x icon-styling"
          [ngStyle]="{ color: unpinnedFlagsCount() === 0 ? '#bbbbbb' : '#464646FF' }"></i>
        <span *ngIf="unpinnedFlagsCount() > 0" class="badge">{{ unpinnedFlagsCount() }}</span>
      </a>
    </div>

    <div *ngIf="pictures.length > 1">
      <i *ngIf="currentPicture > 0" (click)="prev()" class="fa fa-chevron-left has-prev"></i>
      <i *ngIf="hasNext()" (click)="next()" class="fa fa-chevron-right has-next"></i>
    </div>

    <div class="date-bottom">
      {{ formattedDateTime(currentPictureDisplayTimestamp()) }}
    </div>
  </div>

  <div [ngStyle]="pictures.length > 1 ? { width: '250px', position: 'relative' } : {}">
    <div style="display: flex; flex-direction: column; height: 100%">
      <div
        style="padding: 10px 30px; flex: 1; white-space: normal; text-align: center"
        *ngIf="pictures.length > 1"
        id="thumbs"
        [perfectScrollbar]>
        <div
          class="thumb"
          *ngFor="let o of pictures; index as i"
          [ngClass]="{ current: currentPicture == i }"
          (click)="currentPicture = i"
          style="max-height: none">
          <img-ajax [src]="o.Location" #thumb> </img-ajax>
          <span class="related" *ngIf="o.related">
            <i class="fa fa-chain"></i>
          </span>
        </div>
      </div>

      <div style="height: 250px; width: 100%; padding: 10px" *ngIf="checkCoordinates()">
        <div
          style="height: 100%"
          leaflet
          (leafletMapReady)="onMapReady($event)"
          [leafletOptions]="lOptions"
          [leafletLayers]="lLayers"></div>
      </div>
    </div>
  </div>

  <div id="right-column" *ngIf="showFlags" [ngStyle]="{ flex: showFlags ? rightColumnFlexValue : '0' }">
    <app-unpinned-flags
      [picture]="pictures[currentPicture]"
      (flagPinned)="flagPinned($event)"
      (close)="closeFlags()"
      [pictureAnswer]="getAnswerForCurrentPicture()">
    </app-unpinned-flags>
  </div>
</div>

<app-add-flag #addFlagModal></app-add-flag>
<app-edit-flag #editFlagModal></app-edit-flag>
